import {React, useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Col, Container, Row } from "react-bootstrap";
import "./ServicesBanner.css";

const ServicesBanner = (props) =>{
    useEffect(() => {
        AOS.init({
        once:'true',
          disable: function() {
          var maxWidth = 992;
          return window.innerWidth < maxWidth;
          }
       });
    } , [])
    return(
        <>
            <div className="about-banner-sc service-overview-banner" style={{paddingTop: props.heightPass}} >
                <Container>
                    <Row>
                        <Col>
                            <div className="banner-name">
                                <h3>Our Services</h3>
                            </div>
                            <h2 className="banner-description">Transforming businesses with <br/> innovative, reliable, and scalable <br/> services for a seamless digital journey.</h2>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default ServicesBanner;